import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconNames } from '@dotcom/crown-ui';
import { IconButton } from '../../icon-button/icon-button';
import { EditAddressButtonProps } from '../recipient-addresses-dialog-types';
import styles from '../recipient-addresses-dialog.module.scss';

export const EditButton = ({ onEditButtonClick }: EditAddressButtonProps) => {
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={onEditButtonClick}
      variant="primary"
      testId="detail-recipients-edit-button"
      className={styles.editButton}
      iconTestId={'icon-Edit'}
      label={t('recipientAddresses.address.editButton')}
      iconPosition="right"
      iconSize="14"
      iconName={IconNames.Edit}
    />
  );
};
